var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheBasePageLayout',{attrs:{"fullSidebar":"","pageHeading":"Adoptions"}},[_c('div',{attrs:{"slot":"sidebar"},slot:"sidebar"},[_c('SidebarFilterAdoptions')],1),_c('div',{attrs:{"slot":"main"},slot:"main"},[_c('TableAdoptionSearchResults')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }